
const StorageHelper = () => {

    const isBrowser = typeof window !== 'undefined'

    const AUTH_USER = 'authUser';
    const LANGUAGE = 'facturee_lang';
    const THEME = 'facturee_theme';
    const MENU_OPEN = 'menu_open';

    const setLanguage = (lang: string): void => {
        localStorage.setItem(LANGUAGE, lang);
    }
    const getLanguage = (): string => {
        if (isBrowser) {
            let selectedLang = localStorage.getItem(LANGUAGE) ?? 'en';
            if (!localStorage.getItem(LANGUAGE)) {
                localStorage.setItem(LANGUAGE, selectedLang);
            }
            return selectedLang;
        }
        return 'en';
    }
    const getTheme = (): 'dark'|'light' => {
        let savedTheme = 'light';
        if (isBrowser) {
            savedTheme = localStorage.getItem(THEME) ?? 'light';
        }
        return savedTheme as 'dark'|'light';
    }

    const setTheme = (theme: string): void => {
        if (isBrowser) {
            localStorage.setItem(THEME, theme);
        }
    }

    const getMenuOpen = (): string => {
        let savedMenuOpen = 'open';
        if (isBrowser) {
            savedMenuOpen = localStorage.getItem(MENU_OPEN) ?? 'open';
        }
        return savedMenuOpen;
    }

    const setMenuOpen = (menuOpen: string): void => {
        if (isBrowser) {
            localStorage.setItem(MENU_OPEN, menuOpen);
        }
    }

    const setData = (key: string, data: any): void => {
        localStorage.setItem(key, data);
    }
    const getData = (key: string): string | null => {
        let data = localStorage.getItem(key);
        if (data && data.length > 0) {
            return data;
        }
        return null;
    }
    const removeData = (key: string): void => {
        localStorage.removeItem(key);
    }

    return {
        setLanguage: setLanguage,
        getLanguage: getLanguage,
        getTheme: getTheme,
        setTheme: setTheme,
        setMenuOpen: setMenuOpen,
        getMenuOpen: getMenuOpen,
        setData: setData,
        getData: getData,
        removeData: removeData
    };
}
export default StorageHelper();
